const DarkModeToggle = ({ isDarkMode, toggleDarkMode }) => {
  return (
    <button 
      onClick={toggleDarkMode}
      className="w-10 h-10 flex items-center justify-center rounded-full text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white focus:outline-none border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 shadow-sm transition-colors"
      aria-label="Toggle dark mode"
    >
      {isDarkMode ? (
        <i className="fa-solid fa-sun"></i>
      ) : (
        <i className="fa-solid fa-moon"></i>
      )}
    </button>
  );
};

export default DarkModeToggle;
